import { alertsStore } from "../store";

type SetAlertParams = {
  show: boolean;
  message: string;
  title: string;
};

export const setAlert = ({ message, title, show }: SetAlertParams) => {
  alertsStore.show = show;
  alertsStore.message = message;
  alertsStore.title = title;
};
